<noscript>
    <img
        class="w-full"
        [ngClass]="additionalClasses()"
        [src]="defaultSrc()"
        [alt]="altText()"
        loading="lazy" />
</noscript>
<img
    class="blur-up lazyload w-full"
    [attr.data-src]="defaultSrc()"
    [attr.data-srcset]="sourceSet()"
    [src]="svgPlaceholder()"
    [alt]="altText()"
    [ngClass]="additionalClasses()" />
